import { render } from "./AdminProjects.vue?vue&type=template&id=3844f060&scoped=true"
import script from "./AdminProjects.vue?vue&type=script&lang=js"
export * from "./AdminProjects.vue?vue&type=script&lang=js"

import "./AdminProjects.vue?vue&type=style&index=0&id=3844f060&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3844f060"]])

export default __exports__